<template>
  <v-container fluid class="opacity-slider">
    <!-- class="mt-16 pa-0" -->
    <v-row
      :class="{
        'mt-12': this.$store.getters.isMobile,
        'mt-16': !this.$store.getters.isMobile,
        'pa-0': true,
        'force-width': this.forceWidth,
      }"
      justify="center"
      no-gutters
    >
      <v-col lg="4" class="opacity-slider-container px-2">
        <LegislativeTypeSelector />

        <v-slider
          step=".01"
          min="0"
          max="2"
          ref="opacitySlider"
          @change="updateUrl"
          :disabled="sliderDisabled"
          v-model="opacity.value"
        >
          <template v-slot:prepend>
            <v-icon
              :color="A_Color"
              :disabled="$store.getters.getSideADisplayName.length === 0"
              >mdi-map</v-icon
            >
            <div
              class="subtitle font-weight-bold"
              v-bind:style="{ color: A_Color }"
            >
              {{ $store.getters.getSideADisplayName }}
            </div>
          </template>
          <template v-slot:append>
            <v-icon
              :color="B_Color"
              :disabled="$store.getters.getSideBDisplayName.length === 0"
              >mdi-map</v-icon
            >
            <div
              class="subtitle right font-weight-bold"
              v-bind:style="{ color: B_Color }"
            >
              {{ $store.getters.getSideBDisplayName }}
            </div>
          </template>
        </v-slider>
      </v-col>
    </v-row>
    <v-row class="unselect-row ma-0 pa-0" justify="center" no-gutters>
      <v-btn
        class="mx-4"
        small
        :disabled="!districtsSelected"
        color="accent"
        @click="unselect()"
        elevation="2"
        data-cy="clear-selected"
        >Clear Selection</v-btn
      >
      <v-btn
        class="mx-4"
        small
        :disabled="!districtsSelected"
        color="accent"
        @click="zoomToSelected()"
        elevation="2"
        >Zoom to Selection</v-btn
      >
    </v-row>
  </v-container>
</template>
<script>
import LegislativeTypeSelector from "./LegistlativeTypeSelector.vue";
import { EventBus } from "../../js/DataManagement/EventBus";

export default {
  name: "OpacitySlider",
  components: { LegislativeTypeSelector },
  data: function () {
    return {
      opacity: { value: 2 },
    };
  },
  mounted: function () {
     let self = this;
    if (this.$querystringManager.route.query.opacity) {
      let val = this.$querystringManager.route.query.opacity;
      this.$nextTick(() => {
        self.$map.once("idle", () => {
          self.$set(self.opacity, "value", val);
        });
      });
    }

    EventBus.$on("sideOpacitySet",(val)=> this.setOpacity(val));

   EventBus.$on("zeroOpacity", () => {
     self.setOpacity(0)
      self.$map.once("idle", () => {
        self.$set(self.opacity, "value", 0);
        
      });
    });
  },
  methods: {
    setOpacity(val) {

      if(this.opacity.value !== val){ this.opacity.value = val}
      EventBus.$emit("mainOpacitySet", val);
      
      
      const Aid = this.$store.getters.getSideAid;
      const ALevel = Math.min(1 - Math.min(val - 1, 1), 1);
      this.$layerManager.setProposalOpacity(`${Aid}-A`, ALevel, "A");

      const Bid = this.$store.getters.getSideBid;
      const BLevel = Math.min(val, 1);
    
      this.$layerManager.setProposalOpacity(`${Bid}-B`, BLevel, "B");

    },
    unselect() {
      EventBus.$emit("clear-selected-districts");
    },
    zoomToSelected() {
      console.log('opacity slider')

      EventBus.$emit("zoom-to-districts");
    },
    updateUrl(val) {
      this.$querystringManager.addQueryParam("opacity", val.toString());
    },
  },
  watch: {
    "opacity.value": function (val) {
      this.setOpacity(val);
    },
    sideAId: function () {
      let self = this;
      this.$map.once("idle", () => {
        self.setOpacity(self.opacity.value);
      });
    },
    sideBId: function () {
      let self = this;
      this.$map.once("idle", () => {
        self.setOpacity(self.opacity.value);
      });
    },
  },
  computed: {
    A_Color: function () {
      const id = this.sideAId;
      const _colorVal = this.$pgConfig.filter((p) => id === p.tablename);

      let _color = "#888";
      if (_colorVal.length > 0) {
        _color = `#${_colorVal[0].mapcolor}`;
      }

      return _color;
      //return this.$styleConfig.styles.outlines.paint["Prop-A"]["line-color"];
    },
    B_Color: function () {
      const id = this.sideBId;
      const _colorVal = this.$pgConfig.filter((p) => id === p.tablename);

      let _color = "#888";
      if (_colorVal.length > 0) {
        _color = `#${_colorVal[0].mapcolor}`;
      }

      return _color;
      //return this.$styleConfig.styles.outlines.paint["Prop-B"]["line-color"];
    },
    sliderDisabled: function () {
      return (
        this.$store.getters.getSideBid.length === 0 ||
        this.$store.getters.getSideAid.length === 0
      );
    },
    sideAId: function () {
      return this.$store.getters.getSideAid;
    },
    sideBId: function () {
      return this.$store.getters.getSideBid;
    },
    districtsSelected: function () {
      return this.$store.getters.getSelectedDistrictSideA || this.$store.getters.getSelectedDistrictSideB
    },
    forceWidth: function () {
      if (this.$store.getters.isMobile) return true;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
      }
      return false;
    },
  },
};
</script>
<style>
.opacity-slider {
  z-index: 2;
  background: none;
  width: 100%;
  position: absolute;
  pointer-events: none;
}
.opacity-slider-container {
  background: white;
  box-shadow: grey 1px 2px 5px;
  pointer-events: all;
}

.subtitle {
  position: absolute;
  font-size: 0.75em;
  bottom: 3.5em;
  margin: 0.5em;
  max-width: 10rem;
}

.subtitle.right {
  transform: translateX(-92%);
}

.unselect-row {
  pointer-events: none;
}

.unselect-row * {
  pointer-events: all;
}
.force-width {
  margin: 0 auto !important;
  max-width: 50%;
}
</style>
